import { useTranslation } from "react-i18next";

export default function Contact() {
  const { t } = useTranslation("contact");
  return (
    <>
      <title>{t("title")}</title>
      <meta name="description" content={t("description")} />
      <div className="p-12">
        <h1 className="text-2xl font-bold">{t("title")}</h1>
      </div>
    </>
  );
}
